import { Component, OnInit, OnDestroy, Output, EventEmitter, Input  } from '@angular/core';
import { ReturnsService } from '../../returns.service';
import { ActivatedRoute, Router } from '@angular/router';
import { STATUS_CODES } from '../../../../constants/status-codes';
import { ApiService } from 'src/app/services/api.service';
import { Subscription } from 'rxjs';
import { FormService } from 'src/app/services/form.service';
import { ToastMessageService } from 'src/app/widgets/toast-message/toast-message.service';

@Component({
  selector: 'app-edit-return-top-bar',
  templateUrl: './edit-return-top-bar.component.html',
  styleUrls: ['./edit-return-top-bar.component.scss']
})
export class EditReturnTopBarComponent implements OnInit, OnDestroy {

  @Input() records: any[];

  @Output() arTransUpdated: EventEmitter<boolean> = new EventEmitter();

  // data
  soHeadId: number;
  returnOrder: any;
  statusCodes: any;

  // processing dialog
  processingDialogTitle = 'Preparing return order printout';
  processingDialogIsOpen = false;

  // finalize dialog
  finalizeDialogOpen: boolean = false;
  finalizeRecordEp: string;
  finalizeRecordId: number;

  // void dialog
  voidDialogOpen: boolean = false;
  voidRecordEp: string;
  voidRecordId: number;
  subject: string = 'return';

  // endpoints
  private _finalizeVoidBaseEp = `${this._apiSvc.endpoints.sales}/api/return`;

  // subscriptions
  private _printSub: Subscription;
  private _returnOrderSub: Subscription;

  constructor(
    private _apiSvc: ApiService,
    private _formSvc: FormService,
    private _returnsSvc: ReturnsService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _toastMsgSvc: ToastMessageService
  ) { }

  ngOnInit() {

    this._route.params.subscribe((params: any) => {
      if (params.soHeadId) {
        this.soHeadId = params.soHeadId;
        this._returnsSvc.getReturn(this.soHeadId);
      }
    });

    this._returnOrderSub = this._returnsSvc.ReturnOrder.subscribe((returnOrder: any) => {
      this.returnOrder = returnOrder;
    });

    const sc = {};
    for (const code of STATUS_CODES) {
      sc[code.value] = code.label;
    }
    this.statusCodes = sc;

  }

  ngOnDestroy() {
    if (this._returnOrderSub) {
      this._returnOrderSub.unsubscribe();
    }
  }

  /**
   * Print button event handler
   * Opens print dialog
   */
  print(): void {

    this.processingDialogIsOpen = true;

    const filename = 'return-order';
    const reportEp = `${this._apiSvc.endpoints.reporting}/api/SalesReturnReporting/getSalesReturnPrintout`;
    const params = {
      SoHeadId: this.soHeadId
    };

    this._printSub = this._apiSvc.getFile(reportEp, params, 'filename')
      .subscribe((res: any) => {
        this._formSvc.downloadGeneratedPdf(res, filename);
        this.processingDialogIsOpen = false;
      }, () => {
        this.processingDialogIsOpen = false;
        this._toastMsgSvc.send({
            icon: 'error_outline',
            message: 'Unable to generate print out',
            type: 'error'
        });
      });

  }

  /**
   * Cancel request to generate print
   */
  onProcessingCancel(): void {
    this._printSub.unsubscribe();
    this.processingDialogIsOpen = false;
  }


  /**
   * Open void dialog
   */
  voidReturn(): void {
    this.voidRecordEp = `${this._finalizeVoidBaseEp}/${this.soHeadId}/Void`;
    this.voidRecordId = this.soHeadId;
    this.voidDialogOpen = true;
  }

  /**
   * Void dialog close event handler
   * @param res
   */
  onVoidConfirm(res: any) {
    this.voidDialogOpen = false;
    if (res.confirm) {
      this._returnsSvc.getReturn(this.soHeadId);
    }
  }

    /**
   * Open void dialog
   */
     finalizeReturn(): void {
      this.finalizeRecordEp = `${this._finalizeVoidBaseEp}/${this.soHeadId}/Finalize`;
      this.finalizeRecordId = this.soHeadId;
      this.finalizeDialogOpen = true;
    }
  
    /**
     * Void dialog close event handler
     * @param res
     */
    onfinalizeConfirm(res: any) {
      this.finalizeDialogOpen = false;
      if (res.confirm) {
        this.arTransUpdated.emit(); 
        this.ngOnInit();        
      }
    }
  
  /**
   * Sales order menu button click event handler
   */
  setDelivery(): void {
    const queryParams = {return: this._router.url.split('/').pop()};
    this._router.navigate([`/sales/returns/${this.soHeadId}/schedule-return`], {queryParams});
  }

  allowFinalize() : boolean {
    const Finalized =  3;
    const Voided = 4;

    let allFinalizedOrVoid: boolean = this.records?.every(record => {
      return record.ItemStatus === Finalized  || record.ItemStatus === Voided;
    })

    return allFinalizedOrVoid;
  }
}
